import * as React from "react";
import classNames from "classnames";

import {SvgIcon} from "./SvgIcon";

interface IProps {
    className?: string;
    fillColor?: string;
    size?: string;
}

export const EnvelopIcon = (props: IProps) => {
    const className = classNames(props.className);

    return (
        <SvgIcon size={props.size || "1"} className={className} fillColor={props.fillColor}>
            <path d="M0.85,8.4c-0.27,0-0.5-0.18-0.57-0.44c-0.01-0.05-0.02-0.1-0.02-0.15V2.81c0-0.06,0.01-0.13,0.03-0.19 c0.08-0.24,0.3-0.4,0.55-0.4h8.3c0.25,0,0.47,0.16,0.55,0.4c0.02,0.06,0.03,0.12,0.03,0.19v5.01c0,0.05-0.01,0.1-0.02,0.15 C9.65,8.22,9.41,8.4,9.15,8.4H0.85z M0.75,8.07h8.5L5.59,5.49L5,5.91L4.4,5.49L0.75,8.07z M5.88,5.28L9.4,7.77V2.8L5.88,5.28z M0.6,7.77l3.52-2.49L0.6,2.8V7.77z M5,5.5l4.17-2.95H0.83L5,5.5z" />
        </SvgIcon>
    );
};
